import * as Telecom from '@servicetitan/telecom-rtcs-client';
import FeatureFlagModule, { FeatureFlagKeys } from '@modules/FeatureFlagModule';
import isValidUser from '../../lib/isValidUser';
import log from '../../lib/log';
import requireUser from '../../lib/requireUser';
import {
  ServiceUserUtils,
  userStatsLastActionTimeFix,
} from '../../lib/serviceUserUtils';
import { userStatsFromAgentStats } from '../../types/ServiceUser';
import { RTCSEventType } from '../../../metrics/rtcsMetrics';
import { trackRTCSEventLatency } from '../../lib/trackRTCSEventLatency';

/**
 * Agent began handling a non-queue (external) call — outbound, DID, internal,
 * etc. RTCS sends `availabilityState: 'On-External-Call'` which maps to the
 * `OnExternalCall` activity status. Availability (Available / AwayFromDesk /
 * etc.) is intentionally not changed here — the agent keeps whatever
 * availability they had; only their activity reflects the in-progress call.
 */
async function handleAgentExternalCallStarted(
  event: Telecom.AgentExternalCallStartedEvent,
) {
  if (
    !FeatureFlagModule.isEnabled(
      FeatureFlagKeys.featureHandleExternalCallEvents,
    )
  ) {
    return;
  }

  trackRTCSEventLatency(
    event.timestamp,
    RTCSEventType.AGENT_EXTERNAL_CALL_STARTED,
  );

  if (!isValidUser(event.agentId)) {
    return;
  }

  const user = await requireUser(event.agentId);
  log('rtcs:agent:external_call_started:' + user?.name, event);

  user.stats = userStatsFromAgentStats(event.stats);
  userStatsLastActionTimeFix({ user, timestamp: event.timestamp });

  ServiceUserUtils.setEventActivityStatus(user, event.availabilityState);
}

export default handleAgentExternalCallStarted;
